import { render, staticRenderFns } from "./BtnExcluirRateiosSelecionados.vue?vue&type=template&id=61ef68ee"
import script from "./BtnExcluirRateiosSelecionados.vue?vue&type=script&lang=js"
export * from "./BtnExcluirRateiosSelecionados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports